import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import "./VGMEmailWindow.css";
import { toast } from "react-toastify";
import moment from "moment";
import {
	useTable,
	usePagination,
	useSortBy,
	useExpanded,
	useGlobalFilter,
	useRowSelect,
} from "react-table";
import { VGM_DATA_EMAIL_COLUMNS } from "../components/columns/VGMEmailColumns";
import { TableCheckbox } from "../components/common/tables/TableCheckbox";
import { getVGMData } from "../services/VGMService";
import { VGMGetDataFilterForMail } from "../utils/dataFilter";
import VGMPDFViewer from "../components/common/VGMPDFViewer";
import {
	htmlEmailSendWithAttachment,
	VGMRecepient,
	CC_VGMRecepient,
} from "../services/emailService";
import { VGMMailBody } from "./VGMMailBody";
import store from "../store/Store";
import { filter } from "lodash";
import MainTablePaginationAdv from "../components/common/tables/MainTablePaginationAdv";
import noDataAvailable from "../assets/img/noDataAvailable.png";
import {
	emailStatusVGMTractor,
	emailStatusVGMAggregate,
	emailStatusVGMFiveM,
} from "../services/emailService";
import { dispatcher } from "../store/storeHelpers";
import * as actionTypes from "../store/ActionTypes";
import Counters from "../components/common/Counters";
import { PulseLoader } from "react-spinners";

function VGMEmailWindow({ type }) {
	const [emailBtn, setEmailBtn] = useState("Send Email");
	const [emailData, setEmailData] = useState([]);
	const [planDate, setPlanDate] = useState({
		fromdate: moment().format("YYYY-MM-DD"),
		todate: moment().format("YYYY-MM-DD"),
	});
	const [tableData, setTableData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [showPDFModal, setShowPDFModal] = useState(null);
	const [userData, setUserData] = useState([]);
	const [filteredUserAccessData, setFilteredUserAccessData] = useState([]);
	const [noDataState, setNoDataState] = useState(false);

	useEffect(() => {
		const unsubscribe = store.subscribe(() => {
			setUserData(Object.values(store.getState().userAccessData));
			setTableData(Object.values(store.getState().VGM_email));
		});
		return () => {
			unsubscribe();
		};
	});

	useEffect(() => {
		setUserData(Object.values(store.getState().userAccessData));
	}, [setUserData]);

	useEffect(() => {
		if (filter(userData, { MenuName: "VGM Email", View: 1 }).length > 0) {
			setFilteredUserAccessData(
				filter(userData, { MenuName: "VGM Email", View: 1 })
			);
		}
	}, [userData]);

	var allowToSend = filter(filteredUserAccessData, { SendEmail: 1 }).length > 0;

	useEffect(() => {
		async function getPlan() {
			if (type === "VGMWindow") {
				var filteredResponse = [];
				setLoading(true);
				try {
					setNoDataState(false);
					const response = await getVGMData(planDate);
					for (let i = 0; i < response.data.length; i++) {
						if (response.data[i]["VGMDoc"]) {
							filteredResponse.push(response.data[i]);
						}
					}
					if (filteredResponse.length === 0) {
						setNoDataState(true);
					}
					dispatcher(
						actionTypes.VGM_EMAIL_DATA,
						VGMGetDataFilterForMail(filteredResponse)
					);
					// setTableData(VGMGetDataFilterForMail(filteredResponse));
					setLoading(false);
				} catch (error) {
					setLoading(false);
					if (error.response.data.StatusCode === 404) {
						setNoDataState(true);
					}
				}
			}
		}
		getPlan();
	}, [planDate, type]);

	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		page,
		nextPage,
		previousPage,
		canNextPage,
		pageOptions,
		pageCount,
		gotoPage,
		state,
		setPageSize,
		canPreviousPage,
		prepareRow,
		selectedFlatRows,
		setGlobalFilter,
	} = useTable(
		{
			columns: VGM_DATA_EMAIL_COLUMNS,
			data: tableData,
			autoResetPage: false,
			initialState: { pageSize: 50 },
			autoResetExpanded: false,
			autoResetGlobalFilter: false,
		},
		useGlobalFilter,
		useSortBy,
		useExpanded,
		usePagination,
		useRowSelect,
		(hooks) => {
			hooks.visibleColumns.push((columns) => [
				{
					id: "selection",
					Header: ({ getToggleAllPageRowsSelectedProps }) => (
						<div>
							<TableCheckbox {...getToggleAllPageRowsSelectedProps()} />
						</div>
					),
					Cell: ({ row }) => (
						<div>
							<TableCheckbox {...row.getToggleRowSelectedProps()} />
						</div>
					),
				},
				...columns,
			]);
		}
	);
	const { pageIndex, pageSize, globalFilter } = state;

	useEffect(() => {
		var planningId = [];
		for (let i = 0; i < selectedFlatRows.length; i++) {
			planningId.push(selectedFlatRows[i].original);
		}
		setEmailData(planningId);
	}, [selectedFlatRows]);

	async function sendEmailHandler() {
		var docArray = [];
		let statusTractorIdList = "";
		let statusAggregateIdList = "";
		let statusFiveMIdList = "";
		let tractorArray = filter(emailData, { DataOf: "TRACTOR" });
		let aggregateArray = filter(emailData, { DataOf: "AGGREGATE" });
		let fiveMArray = filter(emailData, { DataOf: "5M" });
		for (let i = 0; i < tractorArray.length; i++) {
			if (i !== tractorArray.length - 1) {
				statusTractorIdList += tractorArray[i]["VGMId"] + ",";
			} else {
				statusTractorIdList += tractorArray[i]["VGMId"];
			}
		}
		for (let i = 0; i < aggregateArray.length; i++) {
			if (i !== aggregateArray.length - 1) {
				statusAggregateIdList += aggregateArray[i]["VGMId"] + ",";
			} else {
				statusAggregateIdList += aggregateArray[i]["VGMId"];
			}
		}
		for (let i = 0; i < fiveMArray.length; i++) {
			if (i !== fiveMArray.length - 1) {
				statusFiveMIdList += fiveMArray[i]["VGMId"] + ",";
			} else {
				statusFiveMIdList += fiveMArray[i]["VGMId"];
			}
		}

		for (let i = 0; i < emailData.length; i++) {
			docArray.push(emailData[i].VGMDoc);
		}
		try {
			setEmailBtn("Sending...");
			await htmlEmailSendWithAttachment({
				Mailto: VGMRecepient,
				MailCc: CC_VGMRecepient,
				strSubject: `VGM CERTIFICATE-${moment().format("DD-MM-YYYY")}`,
				body: VGMMailBody(),
				attachment: docArray,
				folderName : "ArbCommanFile"
			});
			setEmailBtn("Send Email");
			toast.success("Email sent successfully");

			if (statusTractorIdList !== "") {
				await emailStatusVGMTractor({
					VGMId: statusTractorIdList,
					isEmailSentTractor: 1,
				});
				dispatcher(actionTypes.UPDATE_VGM_EMAIL_DATA_TRACTOR, {
					data: emailData,
					isEmailSentTractor: 1,
				});
			}
			if (statusAggregateIdList !== "") {
				await emailStatusVGMAggregate({
					VGMId: statusAggregateIdList,
					isEmailSentAggregate: 1,
				});
				dispatcher(actionTypes.UPDATE_VGM_EMAIL_DATA_AGGREGATE, {
					data: emailData,
					isEmailSentAggregate: 1,
				});
			}
			if (statusFiveMIdList !== "") {
				await emailStatusVGMFiveM({
					VGMId: statusFiveMIdList,
					isEmailSent5M: 1,
				});
				dispatcher(actionTypes.UPDATE_VGM_EMAIL_DATA_5M, {
					data: emailData,
					isEmailSent5M: 1,
				});
			}
		} catch (error) {
			setEmailBtn("Send Email");
			toast.error("Unable to send email...please try again.");
		}
	}

	const cellRenderHandler = (cell) => {
		if (cell.column.id === "generate_pdf") return "action";
		else return "data";
	};

	function downloadClickHandler(cell) {
		setShowPDFModal(cell);
	}

	return (
		<>
			<div className="emailWindow__container">
				<div className="containerMasterEmailWindowCounterDiv">
					<Counters
						counter={{ Total: tableData.length !== 0 ? tableData.length : 0 }}
						label={["Total"]}
						styleData="df_dailyCounter absolute"
					/>
				</div>
				<div className="invPackingEmail__header__VGMMail">
					<Form.Control
						value={globalFilter || ""}
						onChange={(e) => setGlobalFilter(e.target.value)}
						className="hiden-inp"
						placeholder="search here.."
						style={{ width: "30%", height: "36px" }}
					/>
					<div
						style={{
							display: "flex",
							width: "30%",
							alignItems: "center",
							marginLeft: "10px",
						}}
					>
						<strong>From-</strong>
						<Form.Control
							type="date"
							value={planDate.fromdate}
							onChange={(e) =>{
								if(e.target.value <= planDate.todate){
									setPlanDate({ ...planDate, fromdate: e.target.value })
								}else{
									setPlanDate({ ...planDate, fromdate: planDate.fromdate })
									alert('From date should not greater than To date.')
								}
							}}
							name="fromDate"
						/>
					</div>
					<div
						style={{
							display: "flex",
							width: "30%",
							alignItems: "center",
							marginLeft: "10px",
						}}
					>
						<strong>To-</strong>
						<Form.Control
							type="date"
							value={planDate.todate}
							onChange={(e) =>{
								if(e.target.value >= planDate.fromdate){
									setPlanDate({ ...planDate, todate: e.target.value })
								}else{
									setPlanDate({ ...planDate, todate: planDate.todate })
									alert('To date should not lesser than From date.')
								}
							}}
							name="toDate"
						/>
					</div>
					<Button
						className="btn-primary btn-pill btn-sm mr4 sb VGMMailBtn"
						onClick={sendEmailHandler}
						style={{
							marginTop: "3px",
							marginRight: "20px",
							marginLeft: "10px",
						}}
						disabled={
							emailData.length === 0 ||
							emailBtn === "Sending..." ||
							!allowToSend
						}
					>
						<i class="bx bxs-send"></i>
					</Button>
				</div>
				{/* <hr /> */}
				{loading && (
					<PulseLoader
						color="#007bff"
						size="20px"
						margin="10px"
						style={{ position: "absolute", top: "50vh", left: "45%" }}
					/>
				)}
				{noDataState && (
					<img
						src={noDataAvailable}
						alt="notAvailableImg"
						className="noDataFoundImg"
						// style={{ marginLeft: "-2%" }}
					/>
				)}
				{!noDataState && (
					<>
						<div className="table_container__VGMMail">
							<table {...getTableProps()} className="table mtbs">
								<thead>
									{headerGroups.map((headerGroup) => (
										<tr {...headerGroup.getHeaderGroupProps()}>
											{headerGroup.headers.map((column) => (
												<th
													{...column.getHeaderProps(
														column.getSortByToggleProps()
													)}
												>
													{column.render("Header")}
													{column.id !== "selection" && (
														<i
															className={
																column.isSorted
																	? column.isSortedDesc
																		? "fi fi-rr-angle-small-down head-icon"
																		: "fi fi-rr-angle-small-up head-icon"
																	: "fi fi-rr-circle-small head-icon w"
															}
														></i>
													)}
												</th>
											))}
										</tr>
									))}
								</thead>
								<tbody {...getTableBodyProps()}>
									{page.map((row) => {
										prepareRow(row);
										return (
											<tr {...row.getRowProps()}>
												{row.cells.map((cell) => {
													return (
														<td
															{...cell.getCellProps()}
															className={
																cell.row.subRows.length !== 0
																	? "main-row"
																	: "sub-row"
															}
														>
															<div className="cell-wrap">
																{cellRenderHandler(cell) === "action" && (
																	<Button
																		className="VGMPDFBtn"
																		disabled={!cell.row.original.VGMId}
																		onClick={() => downloadClickHandler(cell)}
																	>
																		<i
																			class="bx bxs-file-pdf"
																			style={{
																				color: `${
																					cell.row.original.VGMId
																						? "red"
																						: "gray"
																				}`,
																				background: "transparent",
																				transform: "scale(1.8)",
																				// marginLeft: "30px",
																				cursor: "pointer",
																			}}
																		></i>
																	</Button>
																)}
																{cell.column.id === "email_status" &&
																	(cell.row.original.isEmailSentTractor === 1 ||
																		cell.row.original.isEmailSentAggregate ===
																			1 ||
																		cell.row.original.isEmailSent5M === 1) && (
																		<button
																			style={{
																				display: "flex",
																				alignItems: "center",
																				background: "transparent",
																				border: "none",
																			}}
																		>
																			<i
																				class="bx bxs-badge-check"
																				style={{
																					color: "green",
																					background: "transparent",
																					transform: "scale(2)",
																					marginLeft: "35px",
																				}}
																			></i>
																		</button>
																	)}
																{cellRenderHandler(cell) === "data" &&
																	cell.render("Cell")}
															</div>
														</td>
													);
												})}
											</tr>
										);
									})}
								</tbody>
							</table>
						</div>

						<MainTablePaginationAdv
							nextPage={nextPage}
							previousPage={previousPage}
							canNextPage={canNextPage}
							pageIndex={pageIndex}
							pageOptions={pageOptions}
							pageSize={pageSize}
							canPreviousPage={canPreviousPage}
							setPageSize={setPageSize}
							gotoPage={gotoPage}
							pageCount={pageCount}
						/>
					</>
				)}
				{showPDFModal && (
					<VGMPDFViewer
						date={planDate}
						show={showPDFModal}
						hide={() => setShowPDFModal(false)}
					/>
				)}
			</div>
		</>
	);
}
export default VGMEmailWindow;
